module.exports = __webpack_public_path__ + "img/page08_text.9218dc10.png";